<script setup lang="ts">
import { computed } from 'vue'

import { t } from '@satch-ui/translations/translations'
import { localizeUrl } from '@shared/fondof-fn/url/localize'
import { useCustomerStore } from '@shared/global-store/stores/customer/customer'
import { useWishlistStore } from '@shared/global-store/stores/wishlist/wishlist'

import { HeartStrokeBlackIcon } from '@fond-of/satch-icons'
import type { Customer } from '@fond-of/shop-api'

const props = defineProps<{
  customer?: Customer
  authorizationRedirectUri: string
}>()

const customerStore = useCustomerStore()
const wishlistStore = useWishlistStore()

const isAuthenticated = computed(() => {
  return !!props.customer || customerStore.isAuthenticated
})

const wishlistHref = computed(() =>
  isAuthenticated.value
    ? localizeUrl('/account/wishlist')
    : props.authorizationRedirectUri
)
</script>

<template>
  <li class="group/parent block w-auto list-none pl-0 pr-0 text-left">
    <a
      :href="wishlistHref"
      class="p-3.75 font-sans-bold flex basis-full items-center pl-5 text-[15px] leading-[21px] text-black"
    >
      <HeartStrokeBlackIcon
        class="mr-3 size-6"
        :class="wishlistStore.itemCount > 0 ? 'text-black' : 'text-white'"
      />
      <span>
        {{ t('wishlist.wishlist') }}
      </span>
      <span
        v-if="wishlistStore.itemCount > 0"
        class="ml-1"
      >
        ({{ wishlistStore.itemCount }})
      </span>
    </a>
  </li>
</template>
